// @ts-nocheck
import { useState, useEffect } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faHeart } from "@fortawesome/free-solid-svg-icons";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";

import useStore from "hooks/useStore";
import FavoritesModal from "./FavoritesModal";

interface Props {
  id: string;
  title: string;
  city: string;
  county: string;
  rating: number;
}

const Content = ({ id, title, city, county, rating }: Props) => {
  const { user, getFavoritesStatus, isFavoritePlace, toggleLoginModal } =
    useStore();
  const [showFavModal, setShowFavModal] = useState(false);

  const hideFavModal = () => setShowFavModal(false);

  const openFavModal = () => {
    if (user?.id) {
      setShowFavModal(true);
    } else {
      toggleLoginModal();
    }
  };

  useEffect(() => {
    if (user?.id) {
      getFavoritesStatus(id);
    }
  }, []);

  return (
    <Container>
      <ContentContainer>
        <Title>{title}</Title>
        <SubtitleContainer>
          <StarIcon icon={faStar} />
          <Subtitle>{rating} · &nbsp;</Subtitle>
          <Subtitle>
            {city} / {county}
          </Subtitle>
        </SubtitleContainer>
      </ContentContainer>
      <ShareContainer>
        <ShareItem onClick={openFavModal}>
          <ShareIcon
            isFavoritePlace={isFavoritePlace().toString()}
            icon={isFavoritePlace() ? faHeart : farHeart}
          />
          <ShareText>Kaydet</ShareText>
        </ShareItem>
      </ShareContainer>
      <FavoritesModal
        showModal={showFavModal}
        hideModal={hideFavModal}
        id={id}
      />
    </Container>
  );
};

const Container = styled.div`
  padding: 48px 0px 24px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #dadada;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ShareContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;

const ShareItem = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

const ShareText = styled.span`
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  border-radius: 8px;
  outline: none;
  padding: 8px;
  transition: box-shadow 0.2s ease 0s, -ms-transform 0.1s ease 0s,
    -webkit-transform 0.1s ease 0s, transform 0.1s ease 0s;
  border: none;
  color: rgb(34, 34, 34);
  text-decoration: underline;
`;

const ShareIcon = styled(FontAwesomeIcon)<{ isFavoritePlace: string }>`
  width: 20px;
  height: 20px;
  cursor: pointer;
  // margin-right: 5px;
  color: ${(props) =>
    props.isFavoritePlace === "true" ? "#e78136" : "rgb(162, 162, 162)"};
`;

const Title = styled.span`
  font-size: 32px;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 8px;
`;

const SubtitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Subtitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
`;

const StarIcon = styled(FontAwesomeIcon)`
  width: 25px;
  height: 25px;
  cursor: pointer;
  margin-right: 5px;
  padding: 1px;
  padding-bottom: 2px;
  color: ${(props) => props.theme.main.primary};
`;

export default Content;
